import classNames from "classnames"

export const GradientBackground = ({
    children,
    className,
    onlyWhenHovered = false,
    borderWidth = 2,
}: {
    children: React.ReactNode
    className?: string
    onlyWhenHovered?: boolean
    borderWidth?: number
}) => {
    return (
        <div
            className={classNames("group/gb relative overflow-hidden", className)}
            style={{ padding: borderWidth }}
        >
            <div
                aria-hidden
                className={classNames(
                    "absolute inset-0 transition-opacity duration-200 pointer-events-none",
                    onlyWhenHovered ? "opacity-0 group-hover/gb:opacity-100" : "opacity-100"
                )}
                style={{ backgroundImage: "linear-gradient(0deg, #5DF2AF, #EAF67C)" }}
            />
            <div
                aria-hidden
                className={classNames(
                    "absolute -inset-10 pointer-events-none animate-spin-create-button z-0 opacity-0 transition-opacity duration-200 delay-0 group-hover/gb:delay-150",
                    "group-hover/gb:opacity-100"
                )}
                style={{
                    background:
                        "conic-gradient(from 0deg, rgba(255,255,255,0) 0deg, rgba(255,255,255,0.5) 20deg, rgba(255,255,255,0) 60deg, rgba(255,255,255,0) 360deg)",
                }}
            />
            <div className="isolate overflow-hidden h-full">{children}</div>
        </div>
    )
}
